import React, { useState } from 'react';
import theme from './OptionCard.module.scss';
import { ProductCard, ProductCardProps } from './ProductCard';
import { OptionItemDto, ProjectFeeSet } from '@/types';
import { PriceDisplay } from './PriceDisplay';
import { Dropdown } from '@ygtechnologies/rubus-ui';
import { faArchive, faCheckSquare, faEdit, faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { archiveOptionItem, setOptionItemAsDefault, unarchiveOptionItem } from '@/services/options/option-items';
import ProjectCatalogProductEditDialog from '../../project-catalog/ProjectCatalogProductEditDialog';
import { Tooltip } from '@ygtechnologies/bygr-frontend-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OptionPresetSelector } from './OptionPresetSelector';

export interface OptionCardProps extends Omit<ProductCardProps, 'product'> {
    option: OptionItemDto;
    onChange?(): void;
    dragProps?: object;
    readOnly?: boolean;
    className?: string;
    projectFeeSet?: ProjectFeeSet | null;
    isOptionGroupPublished?: boolean;
}

export const OptionCard: React.FC<OptionCardProps> = ({
    option,
    onChange,
    dragProps,
    readOnly = true,
    className,
    projectFeeSet,
    isOptionGroupPublished = false,
    ...rest
}) => {
    const [showEditDialog, setShowEditDialog] = useState(false);

    const handleSetAsDefault = async () => {
        await setOptionItemAsDefault(option.id);
        onChange?.();
    };

    const handleArchive = async () => {
        await archiveOptionItem(option.id);
        onChange?.();
    };

    const handleUnarchive = async () => {
        await unarchiveOptionItem(option.id);
        onChange?.();
    };

    const presetSelectorProps = {
        existingPresetItems: option.optionPresetItems.sort((a) => (a.isDefault ? -1 : 1)),
        optionItemId: option.id,
        isOptionGroupPublished,
        onChange,
    } as any;

    return (
        <>
            <ProjectCatalogProductEditDialog
                projectCatalogProductId={option.product.id}
                show={showEditDialog}
                onClose={() => setShowEditDialog(false)}
                onSave={() => onChange?.()}
            />
            <ProductCard
                {...rest}
                className={className}
                product={option.product}
                isDefault={option.isDefault}
                isArchived={option.isArchived}
                priceElement={
                    option.basePrice !== null && (
                        <PriceDisplay
                            basePrice={option.basePrice}
                            finalPrice={option.finalPrice}
                            projectFeeSet={projectFeeSet}
                        />
                    )
                }
                dragProps={readOnly ? undefined : dragProps}
                catalog="project"
                dropdownContent={
                    readOnly ? null : (
                        <>
                            <Dropdown.Item icon={faEdit} onClick={() => setShowEditDialog(true)}>
                                <Trans>Edit product</Trans>
                            </Dropdown.Item>

                            {/* {!option.isArchived && (
                                <Dropdown.Item icon={faArchive} onClick={handleArchive} disabled={option.isDefault}>
                                    <span className={theme.archiveItem}>
                                        <Trans>Archive</Trans>
                                        <Tooltip
                                            content={
                                                <Trans id="archive_option_tooltip_content">
                                                    When archived, home buyers can no longer see and select the product
                                                    unless they've already selectedit.
                                                </Trans>
                                            }>
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                        </Tooltip>
                                    </span>
                                </Dropdown.Item>
                            )}
                            {option.isArchived && (
                                <Dropdown.Item icon={faArchive} onClick={handleUnarchive}>
                                    <span className={theme.archiveItem}>
                                        <Trans>Unarchive</Trans>
                                        <Tooltip
                                            content={
                                                <Trans id="unarchive_option_tooltip_content">
                                                    When unarchived, home buyers can see and select the product.
                                                </Trans>
                                            }>
                                            <FontAwesomeIcon icon={faInfoCircle} />
                                        </Tooltip>
                                    </span>
                                </Dropdown.Item>
                            )} */}
                        </>
                    )
                }
                bottomElement={
                    <OptionPresetSelector {...presetSelectorProps} />
                }
            />
        </>
    );
};
